<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.11111 34C4.51296 34 4.01193 33.808 3.608 33.424C3.20267 33.0413 3 32.5667 3 32C3 31.4333 3.20267 30.9587 3.608 30.576C4.01193 30.192 4.51296 30 5.11111 30H38.8889C39.487 30 39.9881 30.192 40.392 30.576C40.7973 30.9587 41 31.4333 41 32C41 32.5667 40.7973 33.0413 40.392 33.424C39.9881 33.808 39.487 34 38.8889 34H5.11111ZM5.11111 24C4.51296 24 4.01193 23.808 3.608 23.424C3.20267 23.0413 3 22.5667 3 22C3 21.4333 3.20267 20.958 3.608 20.574C4.01193 20.1913 4.51296 20 5.11111 20H38.8889C39.487 20 39.9881 20.1913 40.392 20.574C40.7973 20.958 41 21.4333 41 22C41 22.5667 40.7973 23.0413 40.392 23.424C39.9881 23.808 39.487 24 38.8889 24H5.11111ZM5.11111 14C4.51296 14 4.01193 13.8087 3.608 13.426C3.20267 13.042 3 12.5667 3 12C3 11.4333 3.20267 10.958 3.608 10.574C4.01193 10.1913 4.51296 10 5.11111 10H38.8889C39.487 10 39.9881 10.1913 40.392 10.574C40.7973 10.958 41 11.4333 41 12C41 12.5667 40.7973 13.042 40.392 13.426C39.9881 13.8087 39.487 14 38.8889 14H5.11111Z"
      fill="currentColor"
    />
  </svg>
</template>
